<template>
  <div class="card card-carousel overflow-hidden h-100 p-0" v-if="sliders.length !== 0">
    <div id="carouselExampleCaptions1" class="carousel slide h-100" data-bs-ride="carousel1">
      <div class="carousel-inner border-radius-lg h-100">
        <div v-for="(slider, index) in sliders" :key="slider.id"
          :class="index === 0 ? 'carousel-item h-100 active' : 'carousel-item h-100'" :style="{
            backgroundImage: `url(${slider.image_url})`,
            backgroundSize: 'cover'
          }">
          <div class="carousel-caption d-none d-md-block bottom-0 text-start start-0 ms-5">
            <div class="icon icon-shape icon-sm bg-white text-center border-radius-md mb-3">
              <i class="ni ni-camera-compact text-dark opacity-10"></i>
            </div>
            <h5 class="text-white mb-1">{{ slider.title }}</h5>
            <p>{{ slider.description }}</p>
          </div>
        </div>
        <!-- <div class="carousel-item h-100" :style="{
          backgroundImage: 'url(' + require('@/assets/img/meta/P16-DSC_0266.jpg') + ')',
          backgroundSize: 'cover', backgroundColor: 'black'
        }">
          <div class="carousel-caption d-none d-md-block bottom-0 text-start start-0 ms-5">
            <div class="icon icon-shape icon-sm bg-white text-center border-radius-md mb-3">
              <i class="ni ni-bulb-61 text-dark opacity-10"></i>
            </div>
            <h5 class="text-white mb-1">LIBRAMIENTO ORIENTE</h5>
            <p></p>
          </div>
        </div>
        <div class="carousel-item h-100" :style="{
          backgroundImage: 'url(' + require('@/assets/img/meta/P12-DJI_0456.jpg') + ')',
          backgroundSize: 'cover'
        }">
          <div class="carousel-caption d-none d-md-block bottom-0 text-start start-0 ms-5">
            <div class="icon icon-shape icon-sm bg-white text-center border-radius-md mb-3">
              <i class="ni ni-trophy text-dark opacity-10"></i>
            </div>
            <h5 class="text-white mb-1">LIBRAMIENTO NORTE</h5>
            <p></p>
          </div>
        </div> -->
      </div>
      <button class="carousel-control-prev w-5 me-3" type="button" data-bs-target="#carouselExampleCaptions1"
        data-bs-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Previous</span>
      </button>
      <button class="carousel-control-next w-5 me-3" type="button" data-bs-target="#carouselExampleCaptions1"
        data-bs-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Next</span>
      </button>
    </div>
  </div>
</template>
  
<script>
export default {
  name: "carousel-images",
  data() {
    return {
      sliders: []
    };
  },
  created() {
    this.plain
      .get(`/sliders`)
      .then((response) => {
        if (response.data.length !== 0) {
          response.data.map(slider => {
            if (slider.active)
              this.sliders.push(slider)
          })
        }

      })
      .catch((err) => {
        console.log(err);
      });
  },
};
</script>
  